export const AUTHENTICATION = 'AUTHENTICATION'
export const DASHBOARD = 'DASHBOARD'
export const REGISTER = 'REGISTER'
export const STYLE_GUIDE = 'STYLE_GUIDE'
export const DISCONNECT_REGISTER = 'DISCONNECT_REGISTER'